module.exports = __webpack_public_path__ + "static/media/tipologia10.302e77d5.png";